import { mergeClassNames } from '../../utils/helpers';

export type NavAccess = 'superuser' | 'financial' | 'mentors' | 'users' | 'students' | 'cs' | 'bdr';

const ACCESS_STYLES: Record<NavAccess, { label: string; title: string; className: string }> = {
  superuser: {
    label: 'SU',
    title: 'SuperUser only',
    className: 'bg-customRed/20 text-customRed',
  },
  financial: {
    label: 'FIN',
    title: 'Financial',
    className: 'bg-customGold/20 text-customGold',
  },
  mentors: {
    label: 'MENT',
    title: 'Mentors Manager',
    className: 'bg-customPrimary/20 text-customPrimary',
  },
  users: {
    label: 'USR',
    title: 'Users Manager',
    className: 'bg-customGreen/20 text-customGreen',
  },
  students: {
    label: 'STU',
    title: 'Students Manager',
    className: 'bg-customLila/20 text-customLila',
  },
  cs: {
    label: 'CS',
    title: 'Customer Success',
    className: 'bg-sky-400/20 text-sky-300',
  },
  bdr: {
    label: 'BDR',
    title: 'BDR',
    className: 'bg-white/15 text-customGrey',
  },
};

type Props = {
  access?: NavAccess[];
  className?: string;
};

const NavAccessBadges = ({ access, className }: Props) => {
  if (!access?.length) return null;

  return (
    <span
      title={`Visible to: ${access.map((item) => ACCESS_STYLES[item].title).join(', ')}`}
      className={mergeClassNames('ml-auto flex shrink-0 items-center gap-1 pl-2', className)}
    >
      {access.map((item) => (
        <span
          key={item}
          className={mergeClassNames(
            'rounded px-1 py-px text-[9px] font-bold leading-tight tracking-wide',
            ACCESS_STYLES[item].className
          )}
        >
          {ACCESS_STYLES[item].label}
        </span>
      ))}
    </span>
  );
};

export default NavAccessBadges;
